import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { Tema } from "../types/general";

const defaultValues = {
  data: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalData: 0
  }
}

interface TemaZusProps {
  temas: {
    data: Tema[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalData: number;
    };
  };
  selectedTema: Tema | undefined;
  setTemas: (temas: { data: Tema[]; pagination: any }) => void;
  setSelectedTema: (tema: Tema) => void;
  resetState: () => void;
  removeTema: (id: number) => void;
  updateTema: (tema: Tema) => void;
}

const useTemaStore = create<TemaZusProps>()(
  persist(
    (set, get) => ({
      temas: defaultValues,
      selectedTema: undefined,
      setTemas: (temasResponse) => {
        set({
          temas: {
            data: temasResponse.data || [],
            pagination: temasResponse.pagination || defaultValues.pagination
          }
        });
      },
      setSelectedTema: (tema: Tema) => {
        set({
          selectedTema: tema
        });
      },
      resetState: () => {
        set({
          temas: defaultValues,
          selectedTema: undefined
        });
      },
      removeTema: (id: number) => {
        const { temas } = get();
        const newState = {
          ...temas,
          data: temas.data.filter((item) => id !== item.id)
        };
        set({
          temas: newState
        });
      },
      updateTema: (tema: Tema) => {
        console.log(tema)
        const { temas } = get();
        const newState = {
          ...temas,
          data: temas.data.map((item) => (tema.id === item.id ? { ...item, ...tema } : item))
        };
        set({
          temas: newState,
          selectedTema: tema
        });
      }
    }),
    {
      name: "temas",
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

export default useTemaStore;
